import { SFCC_CART_PATH_DEFAULTS } from '@entities/platform-entities/integration/sfcc-cart-path-defaults.const';
import type { SfccIntegrationConfig } from '@entities/platform-entities/integration/sfcc-integration-config.interface';

export function applySfccIntegrationDefaults(
  config?: SfccIntegrationConfig
): SfccIntegrationConfig {
  return {
    ...SFCC_CART_PATH_DEFAULTS,
    locale: '',
    organizationId: '',
    scapiHost: '',
    siteId: '',
    slasClientId: '',
    slasClientSecret: '',
    ...config,
  };
}
